import posthog from 'posthog-js';

/**
 * Initialize PostHog analytics
 * - Only runs in production environment
 * - Only runs in browser context
 * - Uses environment variable for API key
 */
export const initPostHog = () => {
  // Only run in browser context
  if (typeof window === 'undefined') return;

  // Only initialize in production
  const isProduction = process.env.NODE_ENV === 'production';
  
  // Get PostHog API key from environment variable
  const apiKey = 'phc_Ohys59qbi1rSFa1FxZfj9zMjbBVs1AWfnLMqniBKEJ0';
  
  if (isProduction && apiKey) {
    posthog.init(apiKey, {
      api_host: 'https://us.i.posthog.com',
      // Disable autocapture to reduce noise and improve performance
      autocapture: true,
      // Capture pageviews automatically
      capture_pageview: true,
      // Disable session recording by default
      disable_session_recording: true,
      // Disable debug mode in production
      debug: false,
      // Set a custom property for all events
      loaded: (posthog) => {
        posthog.register({
          app_version: '3.0.0', // Update this with your actual version
          app_name: 'Raidu Website'
        });
      }
    });
    
    console.log('[PostHog] Analytics initialized in production mode');
  } else {
    console.log('[PostHog] Analytics not initialized (development mode or missing API key)');
  }
};

/**
 * Track a custom event with PostHog
 * @param eventName The name of the event to track
 * @param properties Optional properties to include with the event
 */
export const trackEvent = (eventName: string, properties?: Record<string, any>) => {
  if (typeof window === 'undefined') return;
  
  try {
    posthog.capture(eventName, properties);
  } catch (error) {
    console.error('[PostHog] Error tracking event:', error);
  }
};

/**
 * Identify a user in PostHog
 * @param userId The unique identifier for the user
 * @param properties Optional user properties
 */
export const identifyUser = (userId: string, properties?: Record<string, any>) => {
  if (typeof window === 'undefined') return;
  
  try {
    posthog.identify(userId, properties);
  } catch (error) {
    console.error('[PostHog] Error identifying user:', error);
  }
};

/**
 * Reset the current user's identity
 */
export const resetUser = () => {
  if (typeof window === 'undefined') return;
  
  try {
    posthog.reset();
  } catch (error) {
    console.error('[PostHog] Error resetting user:', error);
  }
};
